import { Color, DefaultValue, getAnimateRotationStyle, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  padding: ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
`

export const CloseIconWrapper = styled.figure`
  margin-left: ${Spacing.S12};
  cursor: pointer;
`

export const ArcIconWrapper = styled.figure`
  display: flex;
  ${getAnimateRotationStyle()};
`
